import { gql } from 'apollo-boost';

export const CLOSE_BUSINESS = gql`
  mutation BusinessClose($id: ID!, $clientMutationId: String) {
    business_close(input: { id: $id, clientMutationId: $clientMutationId }) {
      clientMutationId
    }
  }
`;
